import React, { useEffect, useState } from "react";
import api from "../utils/base_url";
import '../styles/index.css';
import '../styles/Footer.css';

/* ── Social definitions ──────────────────────────────────── */
const socials = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/stencils_world54/",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
        fill="none" stroke="url(#ig1)" strokeWidth="2"
        strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <defs>
          <linearGradient id="ig1" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%"  stopColor="#fdf497" />
            <stop offset="45%" stopColor="#fd5949" />
            <stop offset="60%" stopColor="#d6249f" />
            <stop offset="90%" stopColor="#285AEB" />
          </linearGradient>
        </defs>
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
        <line x1="17.5" y1="6.5" x2="17.5" y2="6.5" />
      </svg>
    ),
  },
  // {
  //   label: "Facebook",
  //   href: "https://www.facebook.com/profile.php?id=61566566914989",
  //   icon: (
  //     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
  //       fill="#1877F2" aria-hidden="true">
  //       <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.235 2.686.235v2.97h-1.513c-1.491 0-1.956.93-1.956 1.884v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
  //     </svg>
  //   ),
  // },
  // {
  //   label: "YouTube",
  //   href: "https://www.youtube.com/@Saranyanursery",
  //   icon: (
  //     <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
  //       fill="#FF0000" aria-hidden="true">
  //       <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  //     </svg>
  //   ),
  // },
];

/* ── Quick links ─────────────────────────────────────────── */
const quickLinks = [
  { label: "Terms & Conditions",        href: "/policies#terms"    },
  { label: "Privacy Policy",            href: "/policies#privacy"  },
  { label: "Return & Refund Policy",    href: "/policies#refund"   },
  { label: "Shipping & Payment Policy", href: "/policies#shipping" },
];

/* ── Component ───────────────────────────────────────────── */
const Footer = ({ categories = [] }) => {
  const [footerCategories, setFooterCategories] = useState([]);

  useEffect(() => {
    let didCancel = false;
    const fetchCategories = async () => {
      try {
        const res = await api.get("categorylist/");
        if (!didCancel && res.data?.status && Array.isArray(res.data.data)) {
          setFooterCategories(res.data.data);
        }
      } catch (err) {
        if (!didCancel) console.error("Error fetching footer categories:", err);
      }
    };
    if (categories.length > 0) {
      setFooterCategories(categories);
    } else if (footerCategories.length === 0) {
      fetchCategories();
    }
    return () => { didCancel = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <footer className="footer-wrapper" aria-label="Site footer">

      {/* ── MAP ── */}
      <div className="map-wrapper">
        <iframe
          title="Vannakkarangal Shop Location"
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3886.5642280119487!2d80.21429687507799!3d13.063386887260473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTPCsDAzJzQ4LjIiTiA4MMKwMTMnMDAuNyJF!5e0!3m2!1sen!2sin!4v1782109597128!5m2!1sen!2sin"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
        <div className="map-overlay" aria-hidden="true">
          <span>Find Us Here</span>
        </div>
      </div>

      {/* ── MAIN GRID ── */}
      <div className="footer-info">
        <div className="footer-grid">

          {/* — Brand & Contact — */}
          <div className="footer-brand">
            <p className="footer-brand-name">Stencils World54</p>
            <span className="footer-brand-tagline">Your Style, Our Stencil </span>
            <p className="footer-brand-desc">
              Your creativity, our precision.
            </p>

            <ul className="footer-contact-list" aria-label="Contact information">
              <li>
                <span className="contact-icon" aria-hidden="true">📍</span>
                <span>
                  16/11, veerapandi nagar, 1st St surss cottage,<br />
                  choolaimedu Chennai - 600094
                </span>
              </li>
              <li>
                <span className="contact-icon" aria-hidden="true">📞</span>
                <a href="tel:+918610554890">+91 86105 54890</a>
              </li>
              <li>
                <span className="contact-icon" aria-hidden="true">✉️</span>
                <a href="mailto:thazeema2002@gmail.com">thazeema2002@gmail.com</a>
              </li>
            </ul>
          </div>

          {/* — Quick Links — */}
          <div className="footer-links">
            <h3 className="footer-col-heading">Quick Links</h3>
            <ul className="footer-links-list" aria-label="Quick links">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* — Follow Us — */}
          <div className="footer-social">
            <h3 className="footer-col-heading">Follow Us</h3>
            <div className="social-grid" role="list" aria-label="Social media links">
              {socials.map((s) => (
                <a
                  key={s.href}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn"
                  title={s.label}
                  role="listitem"
                  aria-label={`Follow us on ${s.label}`}
                >
                  {s.icon}
                  <span className="social-label">{s.label}</span>
                </a>
              ))}
            </div>
          </div>

        </div>
      </div>

      {/* ── BOTTOM BAR ── */}
      <div className="footer-bottom" role="contentinfo">
        <small>
          © {new Date().getFullYear()} Stencils World54. All rights reserved.
          &nbsp;·&nbsp; Powered by{" "}
          <a href="https://www.instagram.com/scaleupstores/" target="_blank" rel="noopener noreferrer">
            Scaleup Stores
          </a>
        </small>
      </div>

    </footer>
  );
};

export default Footer;